import { frontApiUrl } from '../../../../core/Api/Front/url';
import { Locale } from '../../../../core/i18n/Locale';
import { DestinationBoundariesSuccessResponseData } from '../../../../pages/api/front/destinations/boundaries';
import { generateUrl } from '../../../../shared/utilities/routing/routing';
import { handleResponse } from '../../../shared/types/handlers';

async function fetchDestinationBoundariesFromFront({
    locale,
    destinationSlug,
}: {
    locale: Locale;
    destinationSlug: string;
}) {
    const response = await fetch(
        frontApiUrl(
            generateUrl('api_destinations_boundaries', locale, {
                destinationSlug,
                locale,
            }),
        ),
    );

    return handleResponse<DestinationBoundariesSuccessResponseData>(response);
}

export async function getDestinationBoundariesFromFront({
    locale,
    destinationSlug,
}: {
    locale: Locale;
    destinationSlug: string;
}) {
    return fetchDestinationBoundariesFromFront({
        locale,
        destinationSlug,
    });
}
